<ng-container *transloco="let t">
  <div class="row mt-5">
    @if (!isHidden(refiPurposeField)) {
      <div class="col-md-6 fv-row">
        <label class="form-label" [ngClass]="{'required': isRequired(refiPurposeField)}">
          {{ getLabel(refiPurposeField, t('wizard.refi.typeOfRefinance')) }}
        </label>
        <select class="form-select form-select-solid" name="refiPurpose"
          [(ngModel)]="subjectProperty.refiPurpose"
          [required]="isRequired(refiPurposeField)"
          #refiPurposeCtrl="ngModel"
          [ngClass]="{'is-invalid': refiPurposeCtrl.touched && refiPurposeCtrl.invalid}">
          <option [ngValue]="undefined">{{ t('common.selectOne') }}</option>
          @for (opt of refinancePurposes; track opt.value) {
            <option [ngValue]="opt.value">{{ opt.name }}</option>
          }
        </select>
      </div>
    }

    @if (!isHidden(refinancePrimaryPurposeField)) {
      <div class="col-md-6 fv-row">
        <label class="form-label" [ngClass]="{'required': isRequired(refinancePrimaryPurposeField)}">
          {{ getLabel(refinancePrimaryPurposeField, t('wizard.refi.purposeOfRefinance')) }}
        </label>
        <select class="form-select form-select-solid" name="refinancePrimaryPurpose"
          [(ngModel)]="subjectProperty.refinancePrimaryPurpose"
          [required]="isRequired(refinancePrimaryPurposeField)"
          #refinancePrimaryPurposeCtrl="ngModel"
          [ngClass]="{'is-invalid': refinancePrimaryPurposeCtrl.touched && refinancePrimaryPurposeCtrl.invalid}">
          <option [ngValue]="undefined">{{ t('common.selectOne') }}</option>
          @for (opt of refinancePrimaryPurposes; track opt.value) {
            <option [ngValue]="opt.value">{{ opt.name }}</option>
          }
        </select>
      </div>
    }
  </div>
</ng-container>
